import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { isTeamAgencyConfigurationRequested, TEAM_AGENCY_CONFIGURATION_PARAM } from "./deepLink";

/**
 * DAT-906 · Applies `?agency_configuration=true` (an agency shift's wage breakdown) once: opens the Agency
 * Configuration tab through `openAgencyTab`, then strips the param so Back does not re-select it over the
 * user's own choice. `openAgencyTab` must be stable (it is an effect dependency).
 *
 * A viewer who cannot see that tab lands on Team through the page's own fallback — the breakdown only
 * renders the link when the tab would show.
 */
export const useAgencyConfigurationDeepLink = (openAgencyTab: () => void) => {
	const [searchParams, setSearchParams] = useSearchParams();
	useEffect(() => {
		if (!isTeamAgencyConfigurationRequested(searchParams)) return;
		openAgencyTab();
		// Updater form, not the snapshot: the Team filters write the same query string in the same tick.
		setSearchParams(
			(current) => {
				const remaining = new URLSearchParams(current);
				remaining.delete(TEAM_AGENCY_CONFIGURATION_PARAM);
				return remaining;
			},
			{ replace: true },
		);
	}, [searchParams, setSearchParams, openAgencyTab]);
};
